import { z } from 'zod'

/**
 * Contratto delle liste dell'area gestionale:
 * GET /api/<risorsa>?q=&<filtri>&sort=&order=&page=&limit= → ListResponse<T>.
 */
export const PAGE_SIZES = [25, 50, 100] as const
export const DEFAULT_PAGE_SIZE = 25
export const LIST_SEARCH_MAX = 100

export type ListResponse<T> = { items: T[]; total: number }

/** Testo di ricerca libera o avanzata; vuoto = nessun vincolo. */
export const searchText = z.string().trim().max(LIST_SEARCH_MAX).optional()

/** Data `YYYY-MM-DD`, come la produce `<input type="date">`. */
export const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional()

/**
 * Schema di una lista: ricerca `q`, ordinamento tra `sorts` (il primo è il default), paginazione e
 * i filtri propri della risorsa (filtri rapidi e campi della ricerca avanzata).
 */
export function listQuerySchema<const S extends [string, ...string[]], F extends z.ZodRawShape>(
  sorts: S,
  filters: F,
  defaultOrder: 'asc' | 'desc' = 'asc',
) {
  return z.object({
    q: searchText,
    sort: z.enum(sorts).default(sorts[0]),
    order: z.enum(['asc', 'desc']).default(defaultOrder),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce
      .number()
      .refine((n) => (PAGE_SIZES as readonly number[]).includes(n))
      .default(DEFAULT_PAGE_SIZE),
    ...filters,
  })
}
